/**
 * Module-level cache for preserving section builder state across navigations.
 *
 * When a user navigates away from a section and comes back, the cached data
 * is restored so they don't lose their query results, summary stats, etc.
 *
 * The cache lives in memory (module scope) and survives as long as the SPA
 * is open — it does NOT persist across page refreshes (which is intentional,
 * since URL params already capture the configuration).
 */

const store = new Map<string, unknown>();

/** Retrieve cached data for a section key, or null if not cached. */
export function getSectionCache<T>(key: string): T | null {
  return (store.get(key) as T) ?? null;
}

/** Store data for a section key. */
export function setSectionCache<T>(key: string, data: T): void {
  store.set(key, data);
}

/** Remove cached data for a section key. */
export function clearSectionCache(key: string): void {
  store.delete(key);
}
